import React from 'react';

const UserContext = React.createContext<unknown>(undefined);

export default UserContext;